import { useVpsHostingSectionContent } from './useVpsHostingSectionContent';
import { parseVpsHostingPackagesContent } from '../utils/vpsHostingContent';

export const useVpsHostingPackagesContent = () =>
  useVpsHostingSectionContent(parseVpsHostingPackagesContent);
